import React, { useState } from 'react';
import { Spin, Alert } from 'antd';
import { usePW933AQuery } from './hooks/usePW933AQuery';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/pw933aApi';
import './PW933AForm.css';

const PW933AForm: React.FC = () => {
  const { loading, result, queried, noData, runQuery } = usePW933AQuery();

  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [deptLevel, setDeptLevel] = useState(1);
  const [deptFrom, setDeptFrom] = useState('');
  const [deptTo, setDeptTo] = useState('');

  const handleQuery = () => {
    const req: QueryRequest = {
      year,
      month,
      deptLevel,
      deptFrom: deptFrom.trim(),
      deptTo: deptTo.trim() || 'ZZZZ',
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="pw933a-container max-w-6xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          部門薪資總表 (pw933af1)
        </h2>

        <QueryParams
          year={year}
          month={month}
          deptLevel={deptLevel}
          deptFrom={deptFrom}
          deptTo={deptTo}
          loading={loading}
          onYearChange={setYear}
          onMonthChange={setMonth}
          onDeptLevelChange={setDeptLevel}
          onDeptFromChange={setDeptFrom}
          onDeptToChange={setDeptTo}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的部門薪資資料！請確認年月及部門範圍是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default PW933AForm;
